<p-table
  #dt1
  selectionMode="multiple"
  [(selection)]="selectedUsers"
  [metaKeySelection]="false"
  dataKey="id"
  [value]="filteredUsers!"
  (selectionChange)="onSelectionChange($event)"
  [globalFilterFields]="['name', 'email', 'fullName']"
>
  <ng-template pTemplate="header">
    <!-- -->
    <tr>
      <th>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input
            type="text"
            pInputText
            [value]="search"
            (input)="onGlobalFilter(dt1, $event)"
            placeholder="{{ 'search' | transloco }}"
          />
        </p-inputgroup>
      </th>

      <th class="d-none d-xl-table-cell">
        <p-columnFilter
          field="rolesNames"
          matchMode="contains"
          [showMenu]="false"
        >
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-dropdown
              [ngModel]="selectedRole"
              [options]="roles"
              (onChange)="onRoleChange($event.value, filter)"
              placeholder="{{ 'select' | transloco }}"
            >
              <ng-template let-option pTemplate="item">
                <p-tag
                  [value]="option.label"
                  [severity]="getSeverity(option.value)"
                ></p-tag>
              </ng-template>
            </p-dropdown>
          </ng-template>
        </p-columnFilter>
      </th>

      <th *ngIf="showUserGroups" class="d-none d-xl-table-cell">
        <p-dropdown
          [ngModel]="selectedGroup"
          [options]="userGroupsWithNoGroup"
          (onChange)="filterByGroup($event.value)"
          placeholder="{{ 'select' | transloco }}"
          [filter]="true"
          [showClear]="true"
          class="w-100"
        >
          <ng-template let-option pTemplate="item">
            <p-tag
              [value]="option.label"
              [severity]="getSeverity(option.value)"
            ></p-tag>
          </ng-template>
        </p-dropdown>
      </th>

      <th class="pe-4cus">
        <div
          class="d-flex justify-content-center align-items-center w-100 h-100 mt-2"
        >
          <p-checkbox
            [(ngModel)]="checked"
            [binary]="true"
            (onChange)="onCheckboxToggle()"
          ></p-checkbox>
          <label for="saveFilterCb" class="label-filt">Save Filter</label>
        </div>
      </th>
    </tr>
    <!-- -->
    <tr>
      <!-- HEADERS -->
      <th class="col-11 col-xl-4">
        <div class="d-flex align-items-center">
          <p-tableHeaderCheckbox class="pe-2 d-none d-md-block" />
          <div pSortableColumn="name" class="flex-grow-1">
            {{ "name" | transloco }}
            <p-sortIcon field="name"></p-sortIcon>
          </div>
        </div>
      </th>
      <th class="col-3 d-none d-xl-table-cell">{{ "roles" | transloco }}</th>
      <th *ngIf="showUserGroups" class="col-4 d-none d-xl-table-cell">
        {{ "groups" | transloco }}
      </th>
      <th class="col-1"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
    <tr>
      <!-- DATA -->
      <td>
        <div style="display: flex; align-items: center">
          <p-tableCheckbox [value]="user" class="pe-2 d-none d-md-block" />
          <app-entity-avatar-init
            [img]="user.imagePath"
            [name]="user.name"
            [surname]="user.surname"
          ></app-entity-avatar-init>
          <div class="ms-2">
            <div [routerLink]="['/users', user.id]">
              {{ user.name | slice: 0 : 15 }}
              {{ user.surname | slice: 0 : 15 }}
            </div>
            <small>
              <span class="txt-email">{{ user.email }}</span>
            </small>
          </div>
        </div>
      </td>
      <td class="d-none d-xl-table-cell">
        <span
          pTooltip="{{ user.rolesNames.join(', ') }}"
          tooltipPosition="top"
          class="text-break splice-text"
        >
          {{ user.rolesNames.join(", ") }}</span
        >
      </td>
      <td *ngIf="showUserGroups" class="d-none d-xl-table-cell">
        <span
          class="text-break splice-text"
          pTooltip="{{ user.groupsNames.join(', ') }}"
          tooltipPosition="top"
          >{{ user.groupsNames.join(", ") }}</span
        >
      </td>
      <td>
        <div style="display: flex; justify-content: end">
          <ng-container *ngIf="!user.deletedAt">
            <button
              mat-icon-button
              [matMenuTriggerFor]="userMenu"
              tabindex="-1"
              class="small-icon-button d-flex justify-content-center align-items-center p-0"
              style="width: 32px; height: 32px; font-size: 20px; line-height: 1"
            >
              <img src="assets/img/dots-vertical.svg" alt="Menu Icon" />
            </button>
            <mat-menu #userMenu="matMenu">
              <button
                mat-menu-item
                [routerLink]="['/users', user.id]"
                title="{{ 'edit' | transloco }}"
              >
                {{ "edit" | transloco }}
              </button>
              <button
                mat-menu-item
                (click)="actionConfirmation = user"
                style="cursor: pointer"
                class="text-danger"
                title="{{ 'delete' | transloco }}"
              >
                {{ "delete" | transloco }}
              </button>
            </mat-menu>
          </ng-container>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-confirm-delete
  id="deleteusermodal"
  *ngIf="actionConfirmation"
  [deleteCandidate]="actionConfirmation.name"
  (confirm)="handleActionClick(actionConfirmation); actionConfirmation = null"
  (cancel)="actionConfirmation = null"
></app-confirm-delete>
